import { Color } from 'three';

export type IColorNumeric = { r: number, g: number, b: number };

export type ColorRepresentation = string | number | Color | IColorNumeric;

export namespace ColorRepresentation {
    export const parse = (value: ColorRepresentation, target?: Color): Color => {
        if (value == null) {
            return target;
        }

        if (value instanceof Color) {
            if (target) {
                target.copy(value);
                return target;
            }
            return value;
        }

        if (typeof value === 'number') {
            const c = target ?? new Color();
            c.setHex(value, '');
            return c;
        }

        if (typeof value === 'string') {
            return target
                ? target.set(value)
                : new Color(value);
        }

        if (typeof value.r !== 'number' || typeof value.g !== 'number' || typeof value.b !== 'number') {
            return target;
        }

        if (target) {
            target.setRGB(value.r, value.g, value.b);
            return target;
        }

        return new Color(value.r, value.g, value.b);
    };

    export const clone = (value: IColorNumeric | Color) => ({ r: value.r, g: value.g, b: value.b });
}
